import { useState } from "react";
import { Grid } from "@mui/material";
import { useStableQuery } from "../../hooks/useStableQuery";
import { api } from "../../../../convex/_generated/api";
import { type DrillState, type TimelineResult, argsForDrill } from "./stageTimelineDrill";
import { StageTimelineChart } from "./StageTimelineChart";
import { StageUnmatchedDonut } from "./StageUnmatchedDonut";

/**
 * Owns the shared drill state (year→month→day) and runs getStageTimeline ONCE,
 * feeding both the stacked bar chart and the "open work" donut so they always
 * reflect the same time selection. Drilling in the bar chart re-scopes the donut.
 */
export function StageInsights() {
  const [drill, setDrill] = useState<DrillState>({ level: "year" });

  const res = useStableQuery(
    api.dashboardCharts.getStageTimeline,
    argsForDrill(drill),
  ) as TimelineResult | undefined;

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} md={8} data-tour="stage-timeline">
        <StageTimelineChart res={res} drill={drill} setDrill={setDrill} />
      </Grid>
      <Grid item xs={12} md={4} data-tour="stage-unmatched">
        <StageUnmatchedDonut res={res} />
      </Grid>
    </Grid>
  );
}
